export default "__VITE_ASSET__CZjDqz2a__"